module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/add-mail/add-mail.component.scss
// module id = ./client/app/add-mail/add-mail.component.scss
// module chunks = main